import Cookies from "js-cookie"
// import { useState } from "react"
// import toast from "react-hot-toast"

const apiClient = async (
  endpoint,
  method = "GET",
  body = null,
  headers = {}
) => {
  const options = {
    method,
    headers: {
      ...headers,
    },
    credentials: "include",
  }

  if (body instanceof FormData) {
    options.body = body // FormData handles its own Content-Type
  } else if (body) {
    options.body = JSON.stringify(body)
    options.headers["Content-Type"] = "application/json" // Only for JSON
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      options
    )

    if (!response.ok) {
      const errorData = await response.json()
      const errorMessage =
        errorData.message || `HTTP error! Status: ${response.status}`

      if (response.status === 401) {
        const retryRes = await fetchWithRefresh({
          endpoint,
          method,
          body,
          headers,
        })
        return retryRes
      }

      if (response.status === 403) {
        Cookies.remove("user")
        window.location.href = "/"
      }

      throw errorMessage
    }

    return await response.json()
  } catch (error) {
    console.log("-> ~ error:", error)
    throw error
  }
}

const fetchWithRefresh = async (options = {}) => {
  const refreshRes = await post("/oauth/refresh-token")
  if (refreshRes) {
    // ✅ return the retried response
    return await apiClient(
      options.endpoint,
      options.method,
      options.body,
      options.headers
    )
  }
  return null
}

export const get = (endpoint) => apiClient(endpoint, "GET")
export const post = (endpoint, body, headers) =>
  apiClient(endpoint, "POST", body, headers)
export const put = (endpoint, body, headers) =>
  apiClient(endpoint, "PUT", body, headers)
export const remove = (endpoint, body) => apiClient(endpoint, "DELETE", body)
